import { Injectable } from '@angular/core';
import { ONBOARD_CONSTANTS } from '../../app.constants';
import { UrlsModel, PnrFormDataModel, GEtDeviceTypeRequestModel, CharterFormDataModel, CrewVoucherDataModel } from './travelers.model';
import { environment } from '../../../environments/environment';
import { AppService } from '../../app.service';


@Injectable()
export class TravelersService {
  private pnrFormData: PnrFormDataModel;
  private crewVoucherFormData: CrewVoucherDataModel;
  private charterFormData: CharterFormDataModel;
  private tncUrls: any;
  alreadyLoggedInErrorCode: string;
  alreadyLoggedInErrors: any;

  constructor(private appService: AppService) { }

  getUrls(): UrlsModel {
    const urls = { wifiLogoUrl: '', sasTACCUrl: '', viasatTACCUrl: '' };

    if (environment.production === true && this.appService.getLanguage() === 'en') {
      const domain = `${window.location.protocol}//${window.location.hostname}`;
      urls.wifiLogoUrl = domain + ONBOARD_CONSTANTS.WIFI_LOGO_URL;
      urls.sasTACCUrl = domain + window.location.pathname + ONBOARD_CONSTANTS.SAS_TAC;
      urls.viasatTACCUrl = domain + window.location.pathname + ONBOARD_CONSTANTS.VIASAT_TAC;
    } else if (environment.production === true && this.appService.getLanguage() !== 'en') {
      const domain = `${window.location.protocol}//${window.location.hostname}`;
      urls.wifiLogoUrl = domain + ONBOARD_CONSTANTS.WIFI_LOGO_URL;
      urls.sasTACCUrl = domain + ONBOARD_CONSTANTS.SAS_TAC;
      urls.viasatTACCUrl = domain + ONBOARD_CONSTANTS.VIASAT_TAC;
    } else if (window.location.hostname === 'localhost' || window.location.hostname.indexOf('d360d') >= 0) {
      urls.wifiLogoUrl = 'https://www.sas.se/content/dam/sas/images/icons/WiFi.svg';
      urls.sasTACCUrl = 'https://www.sas.se/misc/terms-and-conditions/wifi.content.html';
      urls.viasatTACCUrl = 'https://www.sas.se/misc/terms-and-conditions/wifi-viasat.content.html';
    } else {
      const domain = `${window.location.protocol}//${window.location.hostname}`;
      urls.sasTACCUrl = domain + window.location.pathname + ONBOARD_CONSTANTS.SAS_TAC;
      urls.viasatTACCUrl = domain + window.location.pathname + ONBOARD_CONSTANTS.VIASAT_TAC;
      urls.wifiLogoUrl = domain + ONBOARD_CONSTANTS.WIFI_LOGO_URL;
    }
    return urls;
  }

  activateCallRequestUrlForPnr(deviceData, pnrFormData: PnrFormDataModel, devName) {
    const wifiActivateRequestForPnr = {
      url: environment.apiBaseUrl + ONBOARD_CONSTANTS.ACTIVATE_DEVICE.replace('<<token>>', deviceData.token),
      data: {
        'flightId': deviceData.flightId,
        'deviceName': devName,
        'passenger': {
          'firstName': pnrFormData.firstname,
          'lastName': pnrFormData.secondname,
          'bookingReference': pnrFormData.pnr
        }
      }
    }
    return wifiActivateRequestForPnr;
  }
  activateCallRequestUrlForCrewVoucher(deviceData, crewVoucherFormData: CrewVoucherDataModel, devName) {
    const wifiActivateRequestForCrewVoucher = {
      url: environment.apiBaseUrl + ONBOARD_CONSTANTS.ACTIVATE_DEVICE.replace('<<token>>', deviceData.token),
      data: {
        'flightId': deviceData.flightId,
        'deviceName': devName,
        'crew': {
          'firstName': crewVoucherFormData.firstName,
          'lastName': crewVoucherFormData.lastName,
          'email': crewVoucherFormData.email,
          'voucherCode': crewVoucherFormData.voucherCode

        }
      }
    }
    return wifiActivateRequestForCrewVoucher;
  }
  activateCallRequestUrlForVoucher(deviceData, pnrFormData: PnrFormDataModel, devName) {
    const wifiActivateRequestForPnr = {
      url: environment.apiBaseUrl + ONBOARD_CONSTANTS.ACTIVATE_DEVICE.replace('<<token>>', deviceData.token),
      data: {
        'flightId': deviceData.flightId,
        'deviceName': devName,
        'passenger': {
          'firstName': pnrFormData.firstname,
          'lastName': pnrFormData.secondname,
          'bookingReference': pnrFormData.pnr,
          'voucherCode': pnrFormData.vouchercode
        }
      }
    }
    return wifiActivateRequestForPnr;
  }

  activateCallRequestUrlForCharter(deviceData, charterFormData: CharterFormDataModel, devName) {
    const wifiActivateRequestForCharter = {
      url: environment.apiBaseUrl + ONBOARD_CONSTANTS.ACTIVATE_DEVICE.replace('<<token>>', deviceData.token),
      data: {
        'flightId': deviceData.flightId,
        'deviceName': devName,
        'passenger': {
          'firstName': charterFormData.firstname,
          'lastName': charterFormData.secondname,
          'email': charterFormData.email,
          'voucherCode': charterFormData.vouchercode
        }
      }
    }
    return wifiActivateRequestForCharter;
  }

  activateCallRequestUrlForLogin(deviceData, sessionIdentifier, devName) {
    const wifiActivateRequestForLogin = {
      url: environment.apiBaseUrl + ONBOARD_CONSTANTS.ACTIVATE_DEVICE.replace('<<token>>', deviceData.token),
      data: {
        'flightId': deviceData.flightId,
        'deviceName': devName,
        'passenger': {
          'sessionId': sessionIdentifier
        }
      }
    }
    return wifiActivateRequestForLogin;
  }

  getDuration(input) {
    const reptms = /^P(?:(\d+)D)?T(?:(\d+)H)?(?:(\d+)M)?(?:(\d+)S)?$/;
    let hours, minutes, seconds, duration;
    if (reptms.test(input)) {
      const matches = reptms.exec(input);
      if (matches[1] || matches[2]) {
        hours = matches[1] ? Number(matches[1]) * 24 : 0;
        hours += matches[2] ? Number(matches[2]) : 0;
        if (hours < 10) {
          hours = `0${hours}`;
        }
        duration = `${hours}:`;
      } else {
        duration = '00:';
      }
      duration = this.findDurationMatches(duration, matches[3]);
      duration = this.findDurationMatches(duration, matches[4]);
    }
    return duration;
  }

  findDurationMatches(duration, matches) {
    let minutes;
    if (matches) {
      minutes = Number(matches);
      if (minutes < 10) {
        minutes = `0${minutes}`;
      }
      duration = `${duration}${minutes}:`;
    } else {
      duration = `${duration}00:`;
    }
    return duration;
  }

  getDurationBetweenDates(endTime) {
    endTime = endTime + 'Z';
    const timeDifferenceTimeStamp = +(new Date(
      endTime)) - Date.now();
    let seconds = timeDifferenceTimeStamp / 1000;
    const hours = Math.floor(seconds / 3600);
    const hr = hours < 10 ? '0' + hours : hours;
    seconds = seconds % 3600;
    const minutes = Math.floor(seconds / 60);
    const min = minutes < 10 ? '0' + minutes : minutes;
    seconds = seconds % 60;
    const sec = seconds < 10 ? '0' + Math.floor(seconds) : Math.floor(seconds);
    const duration = `${hr}:${min}:${sec}`;
    return duration;
  }
  // Change ends

  getReserveRequest(pnrFormData) {
    const ln = (pnrFormData.secondname) ? pnrFormData.secondname : pnrFormData.lastName;
    const pnr = (pnrFormData.pnr) ? pnrFormData.pnr : pnrFormData.bookingReference;
    const reserveRequest = {
      url: environment.apiBaseUrl + ONBOARD_CONSTANTS.GET_RESERVATION.replace('<<pnr>>', pnr).replace('<<ln>>', ln)
    }
    return reserveRequest;
  }

  getDeviceTypesRequest(passengerId): GEtDeviceTypeRequestModel {
    const requestEntity = {
      url: environment.apiBaseUrl + ONBOARD_CONSTANTS.GET_DEVICE_TYPES.replace('<<passengerId>>', passengerId)
    };
    return requestEntity;
  }

  setAlreadyLoginError(errorCode, alreadyLoggedInErrors) {
    this.alreadyLoggedInErrorCode = errorCode;
    this.alreadyLoggedInErrors = alreadyLoggedInErrors;
  }

  getAlreadyLoginErrorCode() {
    return this.alreadyLoggedInErrorCode;
  }

  getAlreadyLoginErrors() {
    return this.alreadyLoggedInErrors;
  }

  deleteLoggedInInfo() {
    this.alreadyLoggedInErrorCode = '';
    this.alreadyLoggedInErrors = {};
  }

  setPnrFormData(formData) {
    this.pnrFormData = formData;
  }
  setCrewFormData(formData) {
    this.crewVoucherFormData = formData;
  }
  setPnrVoucherFormData(formData,voucherCode) {
    this.pnrFormData = formData;
    this.pnrFormData.vouchercode = voucherCode;
  }
  setCharterFormData(formData) {
    this.charterFormData = formData;
  }

  getPnrFormData() {
    return this.pnrFormData;
  }

  getCrewFormData() {
    return this.crewVoucherFormData;
  }

  getCharterFormData() {
    return this.charterFormData;
  }

  setTnCUrls(value) {
    this.tncUrls = value;
  }

  getTnCUrls() {
    return this.tncUrls;
  }

  getActivateDeviceDetails(activateResponse) {
    let activateDeviceDataMap;
    activateDeviceDataMap = new Map();
    let connectionFullAccess = '';
    if (activateResponse.status && activateResponse.status.code === 'FULL') {
      connectionFullAccess = 'True';
    } else {
      connectionFullAccess = 'false';
    }
    const connectionType = activateResponse.connectionType;
    activateDeviceDataMap.set('connectionFullAccess', connectionFullAccess);
    activateDeviceDataMap.set('connectionType', connectionType);
    return activateDeviceDataMap;
  }

  getSegmentInfoDataFromFlightResponse(segmentInfoMap) {
    const flightResponse = this.appService.getFlightResponse();
    const arrivalGmt = flightResponse.scheduledArrivalGMT;
    const depatureGmt = flightResponse.scheduledDepartureGMT;
    let travelTimeTotal = '', travelTimeLeft = '';
    const cdate = new Date();
    const currentTime = `${cdate.getUTCFullYear()}-${this.lenUpdate(cdate.getUTCMonth() + 1)}-
    ${this.lenUpdate(cdate.getUTCDate())}T${this.lenUpdate(cdate.getUTCHours())}:
    ${this.lenUpdate(cdate.getUTCMinutes())}:${this.lenUpdate(cdate.getUTCSeconds())}Z`;
    if (depatureGmt !== '' && arrivalGmt !== '') {
      travelTimeTotal = this.findTimeDiffer(depatureGmt, arrivalGmt);
      travelTimeLeft = this.findTimeDiffer(currentTime, arrivalGmt);
    }
    segmentInfoMap.set('traveltimetotal', travelTimeTotal);
    segmentInfoMap.set('traveltimeleft', travelTimeLeft);
    return segmentInfoMap;
  }

  lenUpdate(val) {
    val = val.toString();
    if (val.length === 1) {
      val = '0' + val;
    }
    return val;
  }

  findTimeDiffer(fromTime, toTime) {
    fromTime = new Date(fromTime);
    toTime = new Date(toTime);
    const differenceTravel = toTime.getTime() - fromTime.getTime();
    let msec = differenceTravel;
    const hh = Math.floor(msec / 1000 / 60 / 60);
    msec -= hh * 1000 * 60 * 60;
    const mm = Math.floor(msec / 1000 / 60);
    msec -= mm * 1000 * 60;
    const ss = Math.floor(msec / 1000);
    return `${this.lenUpdate(hh)}:${this.lenUpdate(mm)}:${this.lenUpdate(ss)}`;
  } 

}
